angular.module('impactx.basket').controller('BasketDeletionCtrl', [
    '$scope',
    'id',
    'basketdeletionlabel',
    'revertbuttonlabel',
    'active',
    'withnewdata',
    '$mdToast',
    '$context',
    'dataGen',
    'basketTemplateMenu',
    'themeFactory',
    BasketDeletionCtrl]);

function BasketDeletionCtrl($scope, id, basketdeletionlabel, revertbuttonlabel, active, withnewdata, $mdToast, $context, dataGen, basketTemplateMenu,
                            themeFactory)
{
    $scope.label = basketdeletionlabel;
    $scope.buttonLabel = revertbuttonlabel;
    $scope.id = id;
    $scope.theme = themeFactory.getTheme();

    this.revertBasketDeletion = function ()
    {
        var dataObj = {
            id: $scope.id,
            withActivation: active,
            withNewData: withnewdata
        };

        dataGen.post($scope, dataObj, "/basket/revertdeletion").then(function (data)
        {
            $context.refreshBasket({}, dataGen, $context);
            $mdToast.hide("reverted");
            if(data.data && (data.data.basket.isCompanyTemplate || data.data.basket.isUserTemplate)) {
                basketTemplateMenu.refreshAllTemplates();
            }
        }, true);
    };
}